export default "__VITE_ASSET__Cqmp0Gll__"